export const AcceptInvitePageWrapper = ({ children }) => {
  return (
    <div className="h-dvh">
      <div className="flex h-full flex-1 flex-col overflow-x-hidden">
        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="m-10 flex flex-col items-center gap-4 md:m-auto md:my-20 md:w-xl">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
